module.exports = __webpack_public_path__ + "img/bell_4.25ccfaee.jpg";